import React from 'react';

import i18n from 'util/i18n';

import { MILITARY, MILITARY_DISCIPLINARY } from 'config/formSections/military';
import { formConfig } from 'config/forms';

import { Summary, DateSummary } from 'components/Summary';

import Procedure from 'components/Section/Military/Disciplinary/Procedure';

import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import Comments from 'components/Form/Comments';

const sectionConfig = {
  key: MILITARY_DISCIPLINARY.key,
  section: MILITARY.name,
  store: MILITARY.store,
  subsection: MILITARY_DISCIPLINARY.name,
  storeKey: MILITARY_DISCIPLINARY.storeKey,
};

export class Disciplinary extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;

    this.update = this.update.bind(this);
    this.updateDisciplinary = this.updateDisciplinary.bind(this);
    this.updateList = this.updateList.bind(this);
    this.summary = this.summary.bind(this);
    this.updateComments = this.updateComments.bind(this);
    this.updateSummaryComments = this.updateSummaryComments.bind(this);
  }

  update(queue) {
    this.props.onUpdate(this.storeKey, {
      HasDisciplinary: this.props.HasDisciplinary,
      List: this.props.List,
      Comments: this.props.Comments,
      SummaryComments: this.props.SummaryComments,
      ...queue,
    });
  }

  updateDisciplinary(values) {
    // If there is no history clear out any previously entered data
    this.update({
      HasDisciplinary: values,
      List: values.value === 'Yes' ? this.props.List : { items: [], branch: {} },
    });
  }

  updateList(values) {
    this.update({
      List: values,
    });
  }

  updateComments(value) {
    this.update({
      Comments: value,
    });
  }

  updateSummaryComments(value) {
    this.update({
      SummaryComments: value,
    });
  }

  /**
   * Assists in rendering the summary section.
   */
  summary = (item, index) => {
    const itemProperties = (item || {}).Item || {};
    const dates = DateSummary(itemProperties.Date);
    const service = itemProperties.Name && itemProperties.Name.value ? itemProperties.Name.value : '';

    return Summary({
      type: i18n.t('military.disciplinary.collection.summary.item'),
      index,
      left: service,
      right: dates,
      placeholder: i18n.t('military.disciplinary.collection.summary.unknown'),
    });
  };

  render() {
    const { formType, errors } = this.props;
    const formTypeConfig = formType && formConfig[formType];
    const years = formTypeConfig && formTypeConfig.MILITARY_DISCIPLINARY_RECORD_YEARS;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    return (
      <div
        className="section-content disciplinary"
        data-section={MILITARY.key}
        data-subsection={MILITARY_DISCIPLINARY.key}
      >
        <h1 className="section-header">{i18n.t('military.destination.disciplinary')}</h1>
        <Branch
          name="has_disciplinary"
          label={i18n.t('military.disciplinary.para.info', { years })}
          labelSize="h4"
          {...this.props.HasDisciplinary}
          weight
          onUpdate={this.updateDisciplinary} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasDisciplinary"
        />
        <Comments
          title={i18n.t('military.disciplinary.comments')}
          name="Comments"
          attribute="Comments"
          className="optional-comments"
          {...this.props.Comments}
          onUpdate={this.updateComments}
          onError={this.props.onError}
          required={false}
        />

        <Show when={this.props.HasDisciplinary.value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={this.props.defaultState}
            scrollToBottom={this.props.scrollToBottom}
            onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            summary={this.summary}
            description={i18n.t('military.disciplinary.collection.summary.title')}
            appendTitle={i18n.t('military.disciplinary.collection.appendTitle', { years })}
            appendLabel={i18n.t('military.disciplinary.collection.append', { years })}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <Procedure
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              attribute="List"
            />
          </Accordion>
          <Comments
            title={i18n.t('military.disciplinary.summarycomments')}
            name="SummaryComments"
            attribute="SummaryComments"
            className="summary-comments"
            {...this.props.SummaryComments}
            onUpdate={this.updateSummaryComments}
            onError={this.props.onError}
            required={false}
          />
        </Show>
      </div>
    );
  }
}

Disciplinary.defaultProps = {
  HasDisciplinary: {},
  List: { items: [] },
  Comments: {},
  SummaryComments: {},
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'military',
  subsection: 'disciplinary',
  dispatch: () => { },
  defaultState: true,
  errors: [],
};

export default connectSubsection(Disciplinary, sectionConfig);
